// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/chat.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OperationResult, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { UserLevel } from "./identity_pb";
import { file_live178_v1_identity } from "./identity_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/chat.proto.
 */
export const file_live178_v1_chat: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_live178_v1_common, file_live178_v1_identity]);

/**
 * @generated from message live178.v1.ChatMessage
 */
export type ChatMessage = Message<"live178.v1.ChatMessage"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: int64 sequence = 3;
   */
  sequence: bigint;

  /**
   * @generated from field: string sender_id = 4;
   */
  senderId: string;

  /**
   * @generated from field: string sender_display_name = 5;
   */
  senderDisplayName: string;

  /**
   * @generated from field: live178.v1.MessageKind kind = 6;
   */
  kind: MessageKind;

  /**
   * @generated from field: string text = 7;
   */
  text: string;

  /**
   * @generated from field: string attachment_id = 8;
   */
  attachmentId: string;

  /**
   * @generated from field: string client_request_id = 9;
   */
  clientRequestId: string;

  /**
   * @generated from field: live178.v1.MessageDeliveryState state = 10;
   */
  state: MessageDeliveryState;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 11;
   */
  sentAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp edited_at = 12;
   */
  editedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */
  deletedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 0);

/**
 * @generated from message live178.v1.MessageAttachment
 */
export type MessageAttachment = Message<"live178.v1.MessageAttachment"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string owner_user_id = 2;
   */
  ownerUserId: string;

  /**
   * @generated from field: string storage_asset_id = 3;
   */
  storageAssetId: string;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * @generated from field: int64 byte_size = 6;
   */
  byteSize: bigint;

  /**
   * @generated from field: bytes sha256 = 7;
   */
  sha256: Uint8Array;

  /**
   * @generated from field: google.protobuf.Struct encryption_metadata = 8;
   */
  encryptionMetadata?: JsonObject | undefined;

  /**
   * @generated from field: live178.v1.AttachmentModerationState moderation_state = 9;
   */
  moderationState: AttachmentModerationState;

  /**
   * @generated from field: string moderation_reason = 10;
   */
  moderationReason: string;

  /**
   * @generated from field: int64 revision = 11;
   */
  revision: bigint;

  /**
   * @generated from field: string conversation_id = 12;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 13;
   */
  messageId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.AttachmentUploadState upload_state = 16;
   */
  uploadState: AttachmentUploadState;

  /**
   * @generated from field: live178.v1.AttachmentScanState scan_state = 17;
   */
  scanState: AttachmentScanState;

  /**
   * @generated from field: int32 scan_attempts = 18;
   */
  scanAttempts: number;

  /**
   * @generated from field: string scan_engine = 19;
   */
  scanEngine: string;

  /**
   * @generated from field: string scan_signature_version = 20;
   */
  scanSignatureVersion: string;

  /**
   * @generated from field: string scan_error = 21;
   */
  scanError: string;

  /**
   * @generated from field: google.protobuf.Timestamp upload_expires_at = 22;
   */
  uploadExpiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 23;
   */
  uploadedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp scan_completed_at = 24;
   */
  scanCompletedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.MessageAttachment.
 * Use `create(MessageAttachmentSchema)` to create a new message.
 */
export const MessageAttachmentSchema: GenMessage<MessageAttachment> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 1);

/**
 * @generated from message live178.v1.AttachmentUploadGrant
 */
export type AttachmentUploadGrant = Message<"live178.v1.AttachmentUploadGrant"> & {
  /**
   * @generated from field: string upload_url = 1;
   */
  uploadUrl: string;

  /**
   * @generated from field: string method = 2;
   */
  method: string;

  /**
   * @generated from field: map<string, string> headers = 3;
   */
  headers: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.AttachmentUploadGrant.
 * Use `create(AttachmentUploadGrantSchema)` to create a new message.
 */
export const AttachmentUploadGrantSchema: GenMessage<AttachmentUploadGrant> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 2);

/**
 * @generated from message live178.v1.BeginMessageAttachmentUploadRequest
 */
export type BeginMessageAttachmentUploadRequest = Message<"live178.v1.BeginMessageAttachmentUploadRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: int64 byte_size = 3;
   */
  byteSize: bigint;

  /**
   * @generated from field: bytes sha256 = 4;
   */
  sha256: Uint8Array;

  /**
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.BeginMessageAttachmentUploadRequest.
 * Use `create(BeginMessageAttachmentUploadRequestSchema)` to create a new message.
 */
export const BeginMessageAttachmentUploadRequestSchema: GenMessage<BeginMessageAttachmentUploadRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 3);

/**
 * @generated from message live178.v1.BeginMessageAttachmentUploadResponse
 */
export type BeginMessageAttachmentUploadResponse = Message<"live178.v1.BeginMessageAttachmentUploadResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;

  /**
   * @generated from field: live178.v1.AttachmentUploadGrant grant = 2;
   */
  grant?: AttachmentUploadGrant | undefined;

  /**
   * @generated from field: bool duplicate = 3;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.BeginMessageAttachmentUploadResponse.
 * Use `create(BeginMessageAttachmentUploadResponseSchema)` to create a new message.
 */
export const BeginMessageAttachmentUploadResponseSchema: GenMessage<BeginMessageAttachmentUploadResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 4);

/**
 * @generated from message live178.v1.CompleteMessageAttachmentUploadRequest
 */
export type CompleteMessageAttachmentUploadRequest = Message<"live178.v1.CompleteMessageAttachmentUploadRequest"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: int64 expected_revision = 2;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string client_request_id = 3;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.CompleteMessageAttachmentUploadRequest.
 * Use `create(CompleteMessageAttachmentUploadRequestSchema)` to create a new message.
 */
export const CompleteMessageAttachmentUploadRequestSchema: GenMessage<CompleteMessageAttachmentUploadRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 5);

/**
 * @generated from message live178.v1.CompleteMessageAttachmentUploadResponse
 */
export type CompleteMessageAttachmentUploadResponse = Message<"live178.v1.CompleteMessageAttachmentUploadResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.CompleteMessageAttachmentUploadResponse.
 * Use `create(CompleteMessageAttachmentUploadResponseSchema)` to create a new message.
 */
export const CompleteMessageAttachmentUploadResponseSchema: GenMessage<CompleteMessageAttachmentUploadResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 6);

/**
 * @generated from message live178.v1.GetMessageAttachmentDownloadRequest
 */
export type GetMessageAttachmentDownloadRequest = Message<"live178.v1.GetMessageAttachmentDownloadRequest"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;
};

/**
 * Describes the message live178.v1.GetMessageAttachmentDownloadRequest.
 * Use `create(GetMessageAttachmentDownloadRequestSchema)` to create a new message.
 */
export const GetMessageAttachmentDownloadRequestSchema: GenMessage<GetMessageAttachmentDownloadRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 7);

/**
 * @generated from message live178.v1.GetMessageAttachmentDownloadResponse
 */
export type GetMessageAttachmentDownloadResponse = Message<"live178.v1.GetMessageAttachmentDownloadResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;

  /**
   * @generated from field: string download_url = 2;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.GetMessageAttachmentDownloadResponse.
 * Use `create(GetMessageAttachmentDownloadResponseSchema)` to create a new message.
 */
export const GetMessageAttachmentDownloadResponseSchema: GenMessage<GetMessageAttachmentDownloadResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 8);

/**
 * @generated from message live178.v1.RegisterMessageAttachmentRequest
 */
export type RegisterMessageAttachmentRequest = Message<"live178.v1.RegisterMessageAttachmentRequest"> & {
  /**
   * @generated from field: string storage_asset_id = 1;
   */
  storageAssetId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: int64 byte_size = 4;
   */
  byteSize: bigint;

  /**
   * @generated from field: bytes sha256 = 5;
   */
  sha256: Uint8Array;

  /**
   * @generated from field: google.protobuf.Struct encryption_metadata = 6;
   */
  encryptionMetadata?: JsonObject | undefined;

  /**
   * @generated from field: string client_request_id = 7;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.RegisterMessageAttachmentRequest.
 * Use `create(RegisterMessageAttachmentRequestSchema)` to create a new message.
 */
export const RegisterMessageAttachmentRequestSchema: GenMessage<RegisterMessageAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 9);

/**
 * @generated from message live178.v1.RegisterMessageAttachmentResponse
 */
export type RegisterMessageAttachmentResponse = Message<"live178.v1.RegisterMessageAttachmentResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.RegisterMessageAttachmentResponse.
 * Use `create(RegisterMessageAttachmentResponseSchema)` to create a new message.
 */
export const RegisterMessageAttachmentResponseSchema: GenMessage<RegisterMessageAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 10);

/**
 * @generated from message live178.v1.GetMessageAttachmentRequest
 */
export type GetMessageAttachmentRequest = Message<"live178.v1.GetMessageAttachmentRequest"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;
};

/**
 * Describes the message live178.v1.GetMessageAttachmentRequest.
 * Use `create(GetMessageAttachmentRequestSchema)` to create a new message.
 */
export const GetMessageAttachmentRequestSchema: GenMessage<GetMessageAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 11);

/**
 * @generated from message live178.v1.GetMessageAttachmentResponse
 */
export type GetMessageAttachmentResponse = Message<"live178.v1.GetMessageAttachmentResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;
};

/**
 * Describes the message live178.v1.GetMessageAttachmentResponse.
 * Use `create(GetMessageAttachmentResponseSchema)` to create a new message.
 */
export const GetMessageAttachmentResponseSchema: GenMessage<GetMessageAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 12);

/**
 * @generated from message live178.v1.ListMessageAttachmentsRequest
 */
export type ListMessageAttachmentsRequest = Message<"live178.v1.ListMessageAttachmentsRequest"> & {
  /**
   * @generated from field: live178.v1.AttachmentModerationState moderation_state = 1;
   */
  moderationState: AttachmentModerationState;

  /**
   * @generated from field: string owner_user_id = 2;
   */
  ownerUserId: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListMessageAttachmentsRequest.
 * Use `create(ListMessageAttachmentsRequestSchema)` to create a new message.
 */
export const ListMessageAttachmentsRequestSchema: GenMessage<ListMessageAttachmentsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 13);

/**
 * @generated from message live178.v1.ListMessageAttachmentsResponse
 */
export type ListMessageAttachmentsResponse = Message<"live178.v1.ListMessageAttachmentsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.MessageAttachment attachments = 1;
   */
  attachments: MessageAttachment[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListMessageAttachmentsResponse.
 * Use `create(ListMessageAttachmentsResponseSchema)` to create a new message.
 */
export const ListMessageAttachmentsResponseSchema: GenMessage<ListMessageAttachmentsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 14);

/**
 * @generated from message live178.v1.ReviewMessageAttachmentRequest
 */
export type ReviewMessageAttachmentRequest = Message<"live178.v1.ReviewMessageAttachmentRequest"> & {
  /**
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: live178.v1.AttachmentModerationState decision = 2;
   */
  decision: AttachmentModerationState;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: int64 expected_revision = 4;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.ReviewMessageAttachmentRequest.
 * Use `create(ReviewMessageAttachmentRequestSchema)` to create a new message.
 */
export const ReviewMessageAttachmentRequestSchema: GenMessage<ReviewMessageAttachmentRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 15);

/**
 * @generated from message live178.v1.ReviewMessageAttachmentResponse
 */
export type ReviewMessageAttachmentResponse = Message<"live178.v1.ReviewMessageAttachmentResponse"> & {
  /**
   * @generated from field: live178.v1.MessageAttachment attachment = 1;
   */
  attachment?: MessageAttachment | undefined;
};

/**
 * Describes the message live178.v1.ReviewMessageAttachmentResponse.
 * Use `create(ReviewMessageAttachmentResponseSchema)` to create a new message.
 */
export const ReviewMessageAttachmentResponseSchema: GenMessage<ReviewMessageAttachmentResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 16);

/**
 * @generated from message live178.v1.ConversationMemberMute
 */
export type ConversationMemberMute = Message<"live178.v1.ConversationMemberMute"> & {
  /**
   * @generated from field: string mute_id = 1;
   */
  muteId: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string imposed_by_user_id = 4;
   */
  imposedByUserId: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp starts_at = 6;
   */
  startsAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 8;
   */
  revokedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 9;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.ConversationMemberMute.
 * Use `create(ConversationMemberMuteSchema)` to create a new message.
 */
export const ConversationMemberMuteSchema: GenMessage<ConversationMemberMute> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 17);

/**
 * @generated from message live178.v1.SetConversationMemberMuteRequest
 */
export type SetConversationMemberMuteRequest = Message<"live178.v1.SetConversationMemberMuteRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int64 duration_seconds = 3;
   */
  durationSeconds: bigint;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.SetConversationMemberMuteRequest.
 * Use `create(SetConversationMemberMuteRequestSchema)` to create a new message.
 */
export const SetConversationMemberMuteRequestSchema: GenMessage<SetConversationMemberMuteRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 18);

/**
 * @generated from message live178.v1.SetConversationMemberMuteResponse
 */
export type SetConversationMemberMuteResponse = Message<"live178.v1.SetConversationMemberMuteResponse"> & {
  /**
   * @generated from field: live178.v1.ConversationMemberMute mute = 1;
   */
  mute?: ConversationMemberMute | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.SetConversationMemberMuteResponse.
 * Use `create(SetConversationMemberMuteResponseSchema)` to create a new message.
 */
export const SetConversationMemberMuteResponseSchema: GenMessage<SetConversationMemberMuteResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 19);

/**
 * @generated from message live178.v1.RevokeConversationMemberMuteRequest
 */
export type RevokeConversationMemberMuteRequest = Message<"live178.v1.RevokeConversationMemberMuteRequest"> & {
  /**
   * @generated from field: string mute_id = 1;
   */
  muteId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: int64 expected_revision = 3;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string client_request_id = 4;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.RevokeConversationMemberMuteRequest.
 * Use `create(RevokeConversationMemberMuteRequestSchema)` to create a new message.
 */
export const RevokeConversationMemberMuteRequestSchema: GenMessage<RevokeConversationMemberMuteRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 20);

/**
 * @generated from message live178.v1.RevokeConversationMemberMuteResponse
 */
export type RevokeConversationMemberMuteResponse = Message<"live178.v1.RevokeConversationMemberMuteResponse"> & {
  /**
   * @generated from field: live178.v1.ConversationMemberMute mute = 1;
   */
  mute?: ConversationMemberMute | undefined;
};

/**
 * Describes the message live178.v1.RevokeConversationMemberMuteResponse.
 * Use `create(RevokeConversationMemberMuteResponseSchema)` to create a new message.
 */
export const RevokeConversationMemberMuteResponseSchema: GenMessage<RevokeConversationMemberMuteResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 21);

/**
 * @generated from message live178.v1.ModerateMessageRequest
 */
export type ModerateMessageRequest = Message<"live178.v1.ModerateMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: live178.v1.MessageModerationAction action = 3;
   */
  action: MessageModerationAction;

  /**
   * @generated from field: string reason_code = 4;
   */
  reasonCode: string;

  /**
   * @generated from field: string reason_detail = 5;
   */
  reasonDetail: string;

  /**
   * @generated from field: string client_request_id = 6;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.ModerateMessageRequest.
 * Use `create(ModerateMessageRequestSchema)` to create a new message.
 */
export const ModerateMessageRequestSchema: GenMessage<ModerateMessageRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 22);

/**
 * @generated from message live178.v1.ModerateMessageResponse
 */
export type ModerateMessageResponse = Message<"live178.v1.ModerateMessageResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.ModerateMessageResponse.
 * Use `create(ModerateMessageResponseSchema)` to create a new message.
 */
export const ModerateMessageResponseSchema: GenMessage<ModerateMessageResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 23);

/**
 * @generated from message live178.v1.Conversation
 */
export type Conversation = Message<"live178.v1.Conversation"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: live178.v1.ConversationType type = 2;
   */
  type: ConversationType;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: int64 last_sequence = 5;
   */
  lastSequence: bigint;

  /**
   * @generated from field: int64 last_read_sequence = 6;
   */
  lastReadSequence: bigint;

  /**
   * @generated from field: int32 member_count = 7;
   */
  memberCount: number;

  /**
   * @generated from field: bool muted = 8;
   */
  muted: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string owner_user_id = 10;
   */
  ownerUserId: string;

  /**
   * @generated from field: string announcement = 11;
   */
  announcement: string;

  /**
   * @generated from field: live178.v1.ConversationMemberRole current_user_role = 12;
   */
  currentUserRole: ConversationMemberRole;

  /**
   * @generated from field: bool can_manage_members = 13;
   */
  canManageMembers: boolean;
};

/**
 * Describes the message live178.v1.Conversation.
 * Use `create(ConversationSchema)` to create a new message.
 */
export const ConversationSchema: GenMessage<Conversation> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 24);

/**
 * @generated from message live178.v1.ChatUser
 */
export type ChatUser = Message<"live178.v1.ChatUser"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string nickname = 2;
   */
  nickname: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: live178.v1.UserLevel user_level = 4;
   */
  userLevel: UserLevel;
};

/**
 * Describes the message live178.v1.ChatUser.
 * Use `create(ChatUserSchema)` to create a new message.
 */
export const ChatUserSchema: GenMessage<ChatUser> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 25);

/**
 * @generated from message live178.v1.ConversationMember
 */
export type ConversationMember = Message<"live178.v1.ConversationMember"> & {
  /**
   * @generated from field: live178.v1.ChatUser user = 1;
   */
  user?: ChatUser | undefined;

  /**
   * @generated from field: live178.v1.ConversationMemberRole role = 2;
   */
  role: ConversationMemberRole;

  /**
   * @generated from field: google.protobuf.Timestamp joined_at = 3;
   */
  joinedAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.ConversationMemberMute active_mute = 4;
   */
  activeMute?: ConversationMemberMute | undefined;
};

/**
 * Describes the message live178.v1.ConversationMember.
 * Use `create(ConversationMemberSchema)` to create a new message.
 */
export const ConversationMemberSchema: GenMessage<ConversationMember> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 26);

/**
 * @generated from message live178.v1.ListRoomMessagesRequest
 */
export type ListRoomMessagesRequest = Message<"live178.v1.ListRoomMessagesRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: int64 after_sequence = 2;
   */
  afterSequence: bigint;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message live178.v1.ListRoomMessagesRequest.
 * Use `create(ListRoomMessagesRequestSchema)` to create a new message.
 */
export const ListRoomMessagesRequestSchema: GenMessage<ListRoomMessagesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 27);

/**
 * @generated from message live178.v1.ListRoomMessagesResponse
 */
export type ListRoomMessagesResponse = Message<"live178.v1.ListRoomMessagesResponse"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: repeated live178.v1.ChatMessage messages = 2;
   */
  messages: ChatMessage[];

  /**
   * @generated from field: int64 latest_sequence = 3;
   */
  latestSequence: bigint;

  /**
   * @generated from field: bool snapshot_required = 4;
   */
  snapshotRequired: boolean;
};

/**
 * Describes the message live178.v1.ListRoomMessagesResponse.
 * Use `create(ListRoomMessagesResponseSchema)` to create a new message.
 */
export const ListRoomMessagesResponseSchema: GenMessage<ListRoomMessagesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 28);

/**
 * @generated from message live178.v1.SendRoomMessageRequest
 */
export type SendRoomMessageRequest = Message<"live178.v1.SendRoomMessageRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: live178.v1.MessageKind kind = 2;
   */
  kind: MessageKind;

  /**
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * @generated from field: string attachment_id = 4;
   */
  attachmentId: string;

  /**
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.SendRoomMessageRequest.
 * Use `create(SendRoomMessageRequestSchema)` to create a new message.
 */
export const SendRoomMessageRequestSchema: GenMessage<SendRoomMessageRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 29);

/**
 * @generated from message live178.v1.SendRoomMessageResponse
 */
export type SendRoomMessageResponse = Message<"live178.v1.SendRoomMessageResponse"> & {
  /**
   * @generated from field: live178.v1.ChatMessage message = 1;
   */
  message?: ChatMessage | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.SendRoomMessageResponse.
 * Use `create(SendRoomMessageResponseSchema)` to create a new message.
 */
export const SendRoomMessageResponseSchema: GenMessage<SendRoomMessageResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 30);

/**
 * @generated from message live178.v1.CreateConversationRequest
 */
export type CreateConversationRequest = Message<"live178.v1.CreateConversationRequest"> & {
  /**
   * @generated from field: live178.v1.ConversationType type = 1;
   */
  type: ConversationType;

  /**
   * @generated from field: repeated string member_user_ids = 2;
   */
  memberUserIds: string[];

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string client_request_id = 4;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.CreateConversationRequest.
 * Use `create(CreateConversationRequestSchema)` to create a new message.
 */
export const CreateConversationRequestSchema: GenMessage<CreateConversationRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 31);

/**
 * @generated from message live178.v1.CreateConversationResponse
 */
export type CreateConversationResponse = Message<"live178.v1.CreateConversationResponse"> & {
  /**
   * @generated from field: live178.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message live178.v1.CreateConversationResponse.
 * Use `create(CreateConversationResponseSchema)` to create a new message.
 */
export const CreateConversationResponseSchema: GenMessage<CreateConversationResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 32);

/**
 * @generated from message live178.v1.ListConversationsRequest
 */
export type ListConversationsRequest = Message<"live178.v1.ListConversationsRequest"> & {
  /**
   * @generated from field: live178.v1.PageRequest page = 1;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListConversationsRequest.
 * Use `create(ListConversationsRequestSchema)` to create a new message.
 */
export const ListConversationsRequestSchema: GenMessage<ListConversationsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 33);

/**
 * @generated from message live178.v1.ListConversationsResponse
 */
export type ListConversationsResponse = Message<"live178.v1.ListConversationsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Conversation conversations = 1;
   */
  conversations: Conversation[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListConversationsResponse.
 * Use `create(ListConversationsResponseSchema)` to create a new message.
 */
export const ListConversationsResponseSchema: GenMessage<ListConversationsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 34);

/**
 * @generated from message live178.v1.SearchChatUsersRequest
 */
export type SearchChatUsersRequest = Message<"live178.v1.SearchChatUsersRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.SearchChatUsersRequest.
 * Use `create(SearchChatUsersRequestSchema)` to create a new message.
 */
export const SearchChatUsersRequestSchema: GenMessage<SearchChatUsersRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 35);

/**
 * @generated from message live178.v1.SearchChatUsersResponse
 */
export type SearchChatUsersResponse = Message<"live178.v1.SearchChatUsersResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ChatUser users = 1;
   */
  users: ChatUser[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.SearchChatUsersResponse.
 * Use `create(SearchChatUsersResponseSchema)` to create a new message.
 */
export const SearchChatUsersResponseSchema: GenMessage<SearchChatUsersResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 36);

/**
 * @generated from message live178.v1.ListConversationMembersRequest
 */
export type ListConversationMembersRequest = Message<"live178.v1.ListConversationMembersRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListConversationMembersRequest.
 * Use `create(ListConversationMembersRequestSchema)` to create a new message.
 */
export const ListConversationMembersRequestSchema: GenMessage<ListConversationMembersRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 37);

/**
 * @generated from message live178.v1.ListConversationMembersResponse
 */
export type ListConversationMembersResponse = Message<"live178.v1.ListConversationMembersResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ConversationMember members = 1;
   */
  members: ConversationMember[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListConversationMembersResponse.
 * Use `create(ListConversationMembersResponseSchema)` to create a new message.
 */
export const ListConversationMembersResponseSchema: GenMessage<ListConversationMembersResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 38);

/**
 * @generated from message live178.v1.AddConversationMembersRequest
 */
export type AddConversationMembersRequest = Message<"live178.v1.AddConversationMembersRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: repeated string member_user_ids = 2;
   */
  memberUserIds: string[];
};

/**
 * Describes the message live178.v1.AddConversationMembersRequest.
 * Use `create(AddConversationMembersRequestSchema)` to create a new message.
 */
export const AddConversationMembersRequestSchema: GenMessage<AddConversationMembersRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 39);

/**
 * @generated from message live178.v1.AddConversationMembersResponse
 */
export type AddConversationMembersResponse = Message<"live178.v1.AddConversationMembersResponse"> & {
  /**
   * @generated from field: live178.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: repeated live178.v1.ConversationMember added_members = 2;
   */
  addedMembers: ConversationMember[];
};

/**
 * Describes the message live178.v1.AddConversationMembersResponse.
 * Use `create(AddConversationMembersResponseSchema)` to create a new message.
 */
export const AddConversationMembersResponseSchema: GenMessage<AddConversationMembersResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 40);

/**
 * @generated from message live178.v1.RemoveConversationMemberRequest
 */
export type RemoveConversationMemberRequest = Message<"live178.v1.RemoveConversationMemberRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string member_user_id = 2;
   */
  memberUserId: string;
};

/**
 * Describes the message live178.v1.RemoveConversationMemberRequest.
 * Use `create(RemoveConversationMemberRequestSchema)` to create a new message.
 */
export const RemoveConversationMemberRequestSchema: GenMessage<RemoveConversationMemberRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 41);

/**
 * @generated from message live178.v1.RemoveConversationMemberResponse
 */
export type RemoveConversationMemberResponse = Message<"live178.v1.RemoveConversationMemberResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;

  /**
   * @generated from field: live178.v1.Conversation conversation = 2;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message live178.v1.RemoveConversationMemberResponse.
 * Use `create(RemoveConversationMemberResponseSchema)` to create a new message.
 */
export const RemoveConversationMemberResponseSchema: GenMessage<RemoveConversationMemberResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 42);

/**
 * @generated from message live178.v1.SetConversationMemberRoleRequest
 */
export type SetConversationMemberRoleRequest = Message<"live178.v1.SetConversationMemberRoleRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string member_user_id = 2;
   */
  memberUserId: string;

  /**
   * @generated from field: live178.v1.ConversationMemberRole role = 3;
   */
  role: ConversationMemberRole;
};

/**
 * Describes the message live178.v1.SetConversationMemberRoleRequest.
 * Use `create(SetConversationMemberRoleRequestSchema)` to create a new message.
 */
export const SetConversationMemberRoleRequestSchema: GenMessage<SetConversationMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 43);

/**
 * @generated from message live178.v1.SetConversationMemberRoleResponse
 */
export type SetConversationMemberRoleResponse = Message<"live178.v1.SetConversationMemberRoleResponse"> & {
  /**
   * @generated from field: live178.v1.ConversationMember member = 1;
   */
  member?: ConversationMember | undefined;
};

/**
 * Describes the message live178.v1.SetConversationMemberRoleResponse.
 * Use `create(SetConversationMemberRoleResponseSchema)` to create a new message.
 */
export const SetConversationMemberRoleResponseSchema: GenMessage<SetConversationMemberRoleResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 44);

/**
 * @generated from message live178.v1.UpdateGroupRequest
 */
export type UpdateGroupRequest = Message<"live178.v1.UpdateGroupRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string announcement = 4;
   */
  announcement: string;
};

/**
 * Describes the message live178.v1.UpdateGroupRequest.
 * Use `create(UpdateGroupRequestSchema)` to create a new message.
 */
export const UpdateGroupRequestSchema: GenMessage<UpdateGroupRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 45);

/**
 * @generated from message live178.v1.UpdateGroupResponse
 */
export type UpdateGroupResponse = Message<"live178.v1.UpdateGroupResponse"> & {
  /**
   * @generated from field: live178.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message live178.v1.UpdateGroupResponse.
 * Use `create(UpdateGroupResponseSchema)` to create a new message.
 */
export const UpdateGroupResponseSchema: GenMessage<UpdateGroupResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 46);

/**
 * @generated from message live178.v1.LeaveConversationRequest
 */
export type LeaveConversationRequest = Message<"live178.v1.LeaveConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message live178.v1.LeaveConversationRequest.
 * Use `create(LeaveConversationRequestSchema)` to create a new message.
 */
export const LeaveConversationRequestSchema: GenMessage<LeaveConversationRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 47);

/**
 * @generated from message live178.v1.LeaveConversationResponse
 */
export type LeaveConversationResponse = Message<"live178.v1.LeaveConversationResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.LeaveConversationResponse.
 * Use `create(LeaveConversationResponseSchema)` to create a new message.
 */
export const LeaveConversationResponseSchema: GenMessage<LeaveConversationResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 48);

/**
 * @generated from message live178.v1.ListMessagesRequest
 */
export type ListMessagesRequest = Message<"live178.v1.ListMessagesRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: int64 before_sequence = 2;
   */
  beforeSequence: bigint;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message live178.v1.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema: GenMessage<ListMessagesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 49);

/**
 * @generated from message live178.v1.ListMessagesResponse
 */
export type ListMessagesResponse = Message<"live178.v1.ListMessagesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ChatMessage messages = 1;
   */
  messages: ChatMessage[];

  /**
   * @generated from field: int64 oldest_sequence = 2;
   */
  oldestSequence: bigint;

  /**
   * @generated from field: bool has_more = 3;
   */
  hasMore: boolean;
};

/**
 * Describes the message live178.v1.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema: GenMessage<ListMessagesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 50);

/**
 * @generated from message live178.v1.SendMessageRequest
 */
export type SendMessageRequest = Message<"live178.v1.SendMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: live178.v1.MessageKind kind = 2;
   */
  kind: MessageKind;

  /**
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * @generated from field: string attachment_id = 4;
   */
  attachmentId: string;

  /**
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 51);

/**
 * @generated from message live178.v1.SendMessageResponse
 */
export type SendMessageResponse = Message<"live178.v1.SendMessageResponse"> & {
  /**
   * @generated from field: live178.v1.ChatMessage message = 1;
   */
  message?: ChatMessage | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 52);

/**
 * @generated from message live178.v1.MarkReadRequest
 */
export type MarkReadRequest = Message<"live178.v1.MarkReadRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: int64 through_sequence = 2;
   */
  throughSequence: bigint;
};

/**
 * Describes the message live178.v1.MarkReadRequest.
 * Use `create(MarkReadRequestSchema)` to create a new message.
 */
export const MarkReadRequestSchema: GenMessage<MarkReadRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 53);

/**
 * @generated from message live178.v1.MarkReadResponse
 */
export type MarkReadResponse = Message<"live178.v1.MarkReadResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.MarkReadResponse.
 * Use `create(MarkReadResponseSchema)` to create a new message.
 */
export const MarkReadResponseSchema: GenMessage<MarkReadResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 54);

/**
 * @generated from message live178.v1.CreateRealtimeTicketRequest
 */
export type CreateRealtimeTicketRequest = Message<"live178.v1.CreateRealtimeTicketRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: repeated string channels = 2;
   */
  channels: string[];
};

/**
 * Describes the message live178.v1.CreateRealtimeTicketRequest.
 * Use `create(CreateRealtimeTicketRequestSchema)` to create a new message.
 */
export const CreateRealtimeTicketRequestSchema: GenMessage<CreateRealtimeTicketRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 55);

/**
 * @generated from message live178.v1.CreateRealtimeTicketResponse
 */
export type CreateRealtimeTicketResponse = Message<"live178.v1.CreateRealtimeTicketResponse"> & {
  /**
   * @generated from field: string ticket = 1;
   */
  ticket: string;

  /**
   * @generated from field: string websocket_url = 2;
   */
  websocketUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.CreateRealtimeTicketResponse.
 * Use `create(CreateRealtimeTicketResponseSchema)` to create a new message.
 */
export const CreateRealtimeTicketResponseSchema: GenMessage<CreateRealtimeTicketResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 56);

/**
 * @generated from message live178.v1.PrewarmConversationKeysRequest
 */
export type PrewarmConversationKeysRequest = Message<"live178.v1.PrewarmConversationKeysRequest"> & {
  /**
   * @generated from field: repeated string conversation_ids = 1;
   */
  conversationIds: string[];

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.PrewarmConversationKeysRequest.
 * Use `create(PrewarmConversationKeysRequestSchema)` to create a new message.
 */
export const PrewarmConversationKeysRequestSchema: GenMessage<PrewarmConversationKeysRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 57);

/**
 * @generated from message live178.v1.PrewarmConversationKeysResponse
 */
export type PrewarmConversationKeysResponse = Message<"live178.v1.PrewarmConversationKeysResponse"> & {
  /**
   * @generated from field: int32 requested = 1;
   */
  requested: number;

  /**
   * @generated from field: int32 warmed = 2;
   */
  warmed: number;

  /**
   * @generated from field: int32 already_cached = 3;
   */
  alreadyCached: number;
};

/**
 * Describes the message live178.v1.PrewarmConversationKeysResponse.
 * Use `create(PrewarmConversationKeysResponseSchema)` to create a new message.
 */
export const PrewarmConversationKeysResponseSchema: GenMessage<PrewarmConversationKeysResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_chat, 58);

/**
 * @generated from enum live178.v1.ConversationType
 */
export enum ConversationType {
  /**
   * @generated from enum value: CONVERSATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONVERSATION_TYPE_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * @generated from enum value: CONVERSATION_TYPE_GROUP = 2;
   */
  GROUP = 2,

  /**
   * @generated from enum value: CONVERSATION_TYPE_LIVE_ROOM = 3;
   */
  LIVE_ROOM = 3,
}

/**
 * Describes the enum live178.v1.ConversationType.
 */
export const ConversationTypeSchema: GenEnum<ConversationType> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 0);

/**
 * @generated from enum live178.v1.ConversationMemberRole
 */
export enum ConversationMemberRole {
  /**
   * @generated from enum value: CONVERSATION_MEMBER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONVERSATION_MEMBER_ROLE_MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: CONVERSATION_MEMBER_ROLE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * @generated from enum value: CONVERSATION_MEMBER_ROLE_OWNER = 3;
   */
  OWNER = 3,
}

/**
 * Describes the enum live178.v1.ConversationMemberRole.
 */
export const ConversationMemberRoleSchema: GenEnum<ConversationMemberRole> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 1);

/**
 * @generated from enum live178.v1.MessageKind
 */
export enum MessageKind {
  /**
   * @generated from enum value: MESSAGE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_KIND_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: MESSAGE_KIND_IMAGE = 2;
   */
  IMAGE = 2,

  /**
   * @generated from enum value: MESSAGE_KIND_VOICE = 3;
   */
  VOICE = 3,

  /**
   * @generated from enum value: MESSAGE_KIND_FILE = 4;
   */
  FILE = 4,

  /**
   * @generated from enum value: MESSAGE_KIND_SYSTEM = 5;
   */
  SYSTEM = 5,

  /**
   * @generated from enum value: MESSAGE_KIND_GIFT = 6;
   */
  GIFT = 6,
}

/**
 * Describes the enum live178.v1.MessageKind.
 */
export const MessageKindSchema: GenEnum<MessageKind> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 2);

/**
 * @generated from enum live178.v1.MessageDeliveryState
 */
export enum MessageDeliveryState {
  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_DELIVERED = 2;
   */
  DELIVERED = 2,

  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_READ = 3;
   */
  READ = 3,

  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: MESSAGE_DELIVERY_STATE_DELETED = 5;
   */
  DELETED = 5,
}

/**
 * Describes the enum live178.v1.MessageDeliveryState.
 */
export const MessageDeliveryStateSchema: GenEnum<MessageDeliveryState> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 3);

/**
 * @generated from enum live178.v1.AttachmentModerationState
 */
export enum AttachmentModerationState {
  /**
   * @generated from enum value: ATTACHMENT_MODERATION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ATTACHMENT_MODERATION_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ATTACHMENT_MODERATION_STATE_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: ATTACHMENT_MODERATION_STATE_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: ATTACHMENT_MODERATION_STATE_QUARANTINED = 4;
   */
  QUARANTINED = 4,
}

/**
 * Describes the enum live178.v1.AttachmentModerationState.
 */
export const AttachmentModerationStateSchema: GenEnum<AttachmentModerationState> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 4);

/**
 * @generated from enum live178.v1.AttachmentUploadState
 */
export enum AttachmentUploadState {
  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_REGISTERED = 1;
   */
  REGISTERED = 1,

  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_INITIATED = 2;
   */
  INITIATED = 2,

  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_UPLOADED = 3;
   */
  UPLOADED = 3,

  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * @generated from enum value: ATTACHMENT_UPLOAD_STATE_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum live178.v1.AttachmentUploadState.
 */
export const AttachmentUploadStateSchema: GenEnum<AttachmentUploadState> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 5);

/**
 * @generated from enum live178.v1.AttachmentScanState
 */
export enum AttachmentScanState {
  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_NOT_STARTED = 1;
   */
  NOT_STARTED = 1,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_SCANNING = 3;
   */
  SCANNING = 3,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_CLEAN = 4;
   */
  CLEAN = 4,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_INFECTED = 5;
   */
  INFECTED = 5,

  /**
   * @generated from enum value: ATTACHMENT_SCAN_STATE_ERROR = 6;
   */
  ERROR = 6,
}

/**
 * Describes the enum live178.v1.AttachmentScanState.
 */
export const AttachmentScanStateSchema: GenEnum<AttachmentScanState> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 6);

/**
 * @generated from enum live178.v1.MessageModerationAction
 */
export enum MessageModerationAction {
  /**
   * @generated from enum value: MESSAGE_MODERATION_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_MODERATION_ACTION_DELETE = 1;
   */
  DELETE = 1,
}

/**
 * Describes the enum live178.v1.MessageModerationAction.
 */
export const MessageModerationActionSchema: GenEnum<MessageModerationAction> = /*@__PURE__*/
  enumDesc(file_live178_v1_chat, 7);

/**
 * @generated from service live178.v1.ChatService
 */
export const ChatService: GenService<{
  /**
   * @generated from rpc live178.v1.ChatService.ListRoomMessages
   */
  listRoomMessages: {
    methodKind: "unary";
    input: typeof ListRoomMessagesRequestSchema;
    output: typeof ListRoomMessagesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.SendRoomMessage
   */
  sendRoomMessage: {
    methodKind: "unary";
    input: typeof SendRoomMessageRequestSchema;
    output: typeof SendRoomMessageResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.CreateConversation
   */
  createConversation: {
    methodKind: "unary";
    input: typeof CreateConversationRequestSchema;
    output: typeof CreateConversationResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ListConversations
   */
  listConversations: {
    methodKind: "unary";
    input: typeof ListConversationsRequestSchema;
    output: typeof ListConversationsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.SearchChatUsers
   */
  searchChatUsers: {
    methodKind: "unary";
    input: typeof SearchChatUsersRequestSchema;
    output: typeof SearchChatUsersResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ListConversationMembers
   */
  listConversationMembers: {
    methodKind: "unary";
    input: typeof ListConversationMembersRequestSchema;
    output: typeof ListConversationMembersResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.AddConversationMembers
   */
  addConversationMembers: {
    methodKind: "unary";
    input: typeof AddConversationMembersRequestSchema;
    output: typeof AddConversationMembersResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.RemoveConversationMember
   */
  removeConversationMember: {
    methodKind: "unary";
    input: typeof RemoveConversationMemberRequestSchema;
    output: typeof RemoveConversationMemberResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.SetConversationMemberRole
   */
  setConversationMemberRole: {
    methodKind: "unary";
    input: typeof SetConversationMemberRoleRequestSchema;
    output: typeof SetConversationMemberRoleResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.UpdateGroup
   */
  updateGroup: {
    methodKind: "unary";
    input: typeof UpdateGroupRequestSchema;
    output: typeof UpdateGroupResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.LeaveConversation
   */
  leaveConversation: {
    methodKind: "unary";
    input: typeof LeaveConversationRequestSchema;
    output: typeof LeaveConversationResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof ListMessagesRequestSchema;
    output: typeof ListMessagesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.MarkRead
   */
  markRead: {
    methodKind: "unary";
    input: typeof MarkReadRequestSchema;
    output: typeof MarkReadResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.RegisterMessageAttachment
   */
  registerMessageAttachment: {
    methodKind: "unary";
    input: typeof RegisterMessageAttachmentRequestSchema;
    output: typeof RegisterMessageAttachmentResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.BeginMessageAttachmentUpload
   */
  beginMessageAttachmentUpload: {
    methodKind: "unary";
    input: typeof BeginMessageAttachmentUploadRequestSchema;
    output: typeof BeginMessageAttachmentUploadResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.CompleteMessageAttachmentUpload
   */
  completeMessageAttachmentUpload: {
    methodKind: "unary";
    input: typeof CompleteMessageAttachmentUploadRequestSchema;
    output: typeof CompleteMessageAttachmentUploadResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.GetMessageAttachment
   */
  getMessageAttachment: {
    methodKind: "unary";
    input: typeof GetMessageAttachmentRequestSchema;
    output: typeof GetMessageAttachmentResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.GetMessageAttachmentDownload
   */
  getMessageAttachmentDownload: {
    methodKind: "unary";
    input: typeof GetMessageAttachmentDownloadRequestSchema;
    output: typeof GetMessageAttachmentDownloadResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ListMessageAttachments
   */
  listMessageAttachments: {
    methodKind: "unary";
    input: typeof ListMessageAttachmentsRequestSchema;
    output: typeof ListMessageAttachmentsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ReviewMessageAttachment
   */
  reviewMessageAttachment: {
    methodKind: "unary";
    input: typeof ReviewMessageAttachmentRequestSchema;
    output: typeof ReviewMessageAttachmentResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.SetConversationMemberMute
   */
  setConversationMemberMute: {
    methodKind: "unary";
    input: typeof SetConversationMemberMuteRequestSchema;
    output: typeof SetConversationMemberMuteResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.RevokeConversationMemberMute
   */
  revokeConversationMemberMute: {
    methodKind: "unary";
    input: typeof RevokeConversationMemberMuteRequestSchema;
    output: typeof RevokeConversationMemberMuteResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.ModerateMessage
   */
  moderateMessage: {
    methodKind: "unary";
    input: typeof ModerateMessageRequestSchema;
    output: typeof ModerateMessageResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.CreateRealtimeTicket
   */
  createRealtimeTicket: {
    methodKind: "unary";
    input: typeof CreateRealtimeTicketRequestSchema;
    output: typeof CreateRealtimeTicketResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ChatService.PrewarmConversationKeys
   */
  prewarmConversationKeys: {
    methodKind: "unary";
    input: typeof PrewarmConversationKeysRequestSchema;
    output: typeof PrewarmConversationKeysResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_chat, 0);

